import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Icon from 'src/@core/components/icon'

const AccesoDenegado = () => {
    return (
        <Box sx={{ p: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Icon icon='mdi:lock-outline' fontSize={72} />
            <Typography variant='h5' sx={{ mt: 4, mb: 1 }}>
                No tenés acceso a esta sección
            </Typography>
            <Typography variant='body2' sx={{ mb: 6, maxWidth: 480 }}>
                Tu usuario no tiene los permisos necesarios para ver esta página. Si creés que deberías tener acceso,
                comunicate con el administrador del sistema.
            </Typography>
            <Button to='/' component={Link} variant='contained' sx={{ px: 5.5 }}>
                Volver al inicio
            </Button>
        </Box>
    )
}

export default AccesoDenegado
